import React from 'react';

interface LoadingSpinnerProps {
  message?: string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  centered?: boolean;
}

/**
 * 共通ローディングスピナーコンポーネント
 * 各ページで共通のローディング表示を提供
 */
const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({ 
  message = '読み込み中...', 
  size = 'md',
  className = '',
  centered = true
}) => {
  const sizeClasses = {
    sm: { spinner: 'spinner-border-sm', container: 'py-3' },
    md: { spinner: '', container: 'py-4' },
    lg: { spinner: 'spinner-border-lg', container: 'py-5' }
  };
  
  const sizeClass = sizeClasses[size] || sizeClasses.md;
  
  const content = (
    <>
      <div className={`spinner-border text-primary ${sizeClass.spinner}`} role="status">
        <span className="visually-hidden">{message}</span>
      </div>
      {message && <p className="mt-2 text-muted">{message}</p>}
    </>
  );
  
  if (centered) {
    return (
      <div className={`d-flex flex-column justify-content-center align-items-center text-center ${sizeClass.container} ${className}`}>
        {content}
      </div>
    );
  }
  
  return (
    <div className={`text-center ${sizeClass.container} ${className}`}>
      {content}
    </div>
  );
};

export default LoadingSpinner; 